"use server"

import { ambilKonfigurasiCaptchaPublik } from "@/modules/captcha/service/captcha"
import type { KonfigurasiCaptchaPublik } from "@/modules/pengaturan/domain/types"

export async function getKonfigurasiCaptcha(): Promise<KonfigurasiCaptchaPublik> {
  return ambilKonfigurasiCaptchaPublik()
}
